import { useRef, useEffect, useState } from 'react';

const useCountdown = (targetDate) => {
  const countDownDate = new Date(targetDate).getTime();
  const intervalRef = useRef(0);
  const [countDown, setCountDown] = useState(
    countDownDate - new Date().getTime(),
  );

  const getReturnValues = (countDownValue) => {
    const days = Math.floor(countDownValue / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (countDownValue % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );
    const minutes = Math.floor(
      (countDownValue % (1000 * 60 * 60)) / (1000 * 60),
    );
    const seconds = Math.floor((countDownValue % (1000 * 60)) / 1000);
    if (seconds + minutes <= 0) {
      clearInterval(intervalRef.current);
    }
    return [days, hours, minutes, seconds];
  };

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCountDown(countDownDate - new Date().getTime());
    }, 1000);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [countDownDate]);

  return getReturnValues(countDown);
};

export default useCountdown;
